import React from 'react';
import Modal from './Modal';
import { disconnectSessions } from '../actions/session';
import ModalText from './ModalText';
import useActivityMonitor from '../hooks/useActivityMonitor';

export const ExtendSessionDlg = () => {
  const activityMonitor = useActivityMonitor();

  const continueSession = () => activityMonitor.extendActivity();

  return (
    <Modal isOpen={activityMonitor.isIdle} onRequestClose={continueSession}>
      <div tracking-module="extend-session">
        <ModalText
          heading="Your session is about to end"
          paragraph={`For added security, you'll be automatically
            logged out and redirected to the login screen in 60 seconds.`}
        />
        <div className="action action--centered">
          <div className="action__item">
            <button
              type="button"
              className="button button--primary"
              onClick={continueSession}
            >
              Continue Session
            </button>
          </div>
          <div className="action__item">
            <button
              type="button"
              className="button"
              onClick={disconnectSessions}
            >
              End Session
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ExtendSessionDlg;
